/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { makeStyles, ThemeProvider, withStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    ...theme.custom.apiOverviewPage.tabs.documentation.styles
  },
  title: {
    paddingTop: '15x',
    textAlign: 'left',
    ...theme.custom.apiOverviewPage.tabs.documentation.documentTypeTextStyle
  },
  tabsBox: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  tabs: {
    backgroundColor: theme.palette.primary.main,
  },
  tab: {
    minHeight: theme.spacing(7.5),
  },
  tabTextParent: {
    maxWidth: theme.spacing(16),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tabTitleText: {
    color: theme.custom.grey,
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'initial',
  },
  markdownViewWrapper: {
    border: `1px solid ${theme.palette.grey[200]}`,
    width: '100%',
    height: '70vh',
    overflowY: 'auto',
  },
}));
